'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSpannerOutline = function TiSpannerOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 26.7c0 0.9-0.7 1.6-1.7 1.6s-1.6-0.7-1.6-1.6c0-1 0.7-1.7 1.6-1.7s1.7 0.7 1.7 1.7z m19.6-18.9c-0.7-0.7-1.7-0.7-2.4 0 0.7-0.7 0.7-1.7 0-2.4-1.8-1.3-4-2.1-6.4-2.1-5.9 0-10.8 4.9-10.8 10.9 0 0.2 0 0.4 0.1 0.6-0.6 0.4-4.9 3.6-7.1 5.5-1.9 1.6-3 4-3 6.4 0 4.6 3.7 8.3 8.3 8.3 2.5 0 4.8-1.1 6.4-3 1.9-2.3 5.1-6.5 5.5-7 0.2 0 0.4 0 0.6 0 6 0 10.9-4.8 10.9-10.8 0-2.4-0.8-4.6-2.1-6.4z m-21.3 23.9c-2.7 0-5-2.3-5-5 0-1.6 0.7-2.9 1.8-3.9 4-3.3 6-4.5 8.5-6.6-0.1-0.7-0.3-1.3-0.3-2 0-4.2 3.4-7.5 7.5-7.5 0.8 0 1.6 0.1 2.3 0.3l-4.8 4.7 0.9 4.1 4.1 0.9 4.7-4.6c0.2 0.7 0.3 1.3 0.3 2.1 0 4.1-3.3 7.5-7.5 7.5-0.7 0-1.3-0.2-2-0.3-2.1 2.5-3.3 4.5-6.7 8.5-0.9 1.1-2.2 1.8-3.8 1.8z m19-21.2l-4.5 4.4-2.2-0.5-0.5-2.2 4.6-4.4c1.1 0.6 2 1.6 2.6 2.7z' })
        )
    );
};

exports.default = TiSpannerOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/spanner-outline.js
// module id = 3222
// module chunks = 0